import _ from "lodash";

import { proNavigator } from "single-spa/react-app/ProNavigator";

export default class LocationService {
    public static getCurrentLocationTracking(): string {
        return LocationService.getLocationTracking(proNavigator.current(), proNavigator.getParams());
    }

    public static getLocationTracking(state: FixmeType, params?: FixmeType): string {
        try {
            const sections = ["section", "subSection", "subSubSection"]
                .map((key) => {
                    const value = state.trackingId[key];
                    return LocationService.camelCaseToCapitalized((_.isFunction(value) ? value(params) : value) || "");
                })
                .join(">")
                .replace(/>$/, ""); // removes ">" at the end

            return `${sections}`;
        } catch (e) {
            return `${state.name}`;
        }
    }

    private static camelCaseToCapitalized(str: string) {
        if (!str) {
            return "";
        }

        str = str.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, "$1 $2");

        return str
            .split(" ")
            .map((s) => {
                s.toLowerCase();
                return s.replace(s[0], s[0].toUpperCase());
            })
            .join(" ");
    }
}
